import { useCallback, useState } from 'react';

export function useToggle(initialState: boolean) {
    const [toggleStatus, setToggleStatus] = useState(initialState);

    const toggle = useCallback(() => setToggleStatus(status => !status), []);

    return [toggleStatus, toggle, setToggleStatus] as const;
}
